var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { separator: "" } },
        [
          _c("el-breadcrumb-item", [
            _c("div", { staticClass: "div1" }, [_vm._v("采购管理")]),
          ]),
          _c("el-breadcrumb-item", [
            _c("div", { staticClass: "div2" }, [_vm._v("采购单列表")]),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tab", staticStyle: { "padding-bottom": "0" } },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "待提交", name: "0" } }),
              _c("el-tab-pane", { attrs: { label: "待审核", name: "1" } }),
              _c("el-tab-pane", { attrs: { label: "已驳回", name: "2" } }),
              _c("el-tab-pane", { attrs: { label: "已完成", name: "3" } }),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShowForm,
                expression: "isShowForm",
              },
            ],
            staticClass: "query",
          },
          [
            _c("div", { staticClass: "header" }, [
              _c("span", { staticStyle: { color: "#333333" } }, [
                _vm._v("数据查询"),
              ]),
              _c(
                "p",
                {
                  staticStyle: {
                    "font-size": "14px",
                    color: "#409eff",
                    cursor: "pointer",
                  },
                  on: {
                    click: function ($event) {
                      _vm.isShowForm = false
                    },
                  },
                },
                [_vm._v(" 收起 ")]
              ),
            ]),
            _vm.activeName == 0
              ? _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: { model: _vm.form0, "label-width": "70px" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "采购编号" } },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "small",
                            clearable: "",
                            placeholder: "请输入采购编号",
                          },
                          model: {
                            value: _vm.form0.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.form0, "code", $$v)
                            },
                            expression: "form0.code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "制单人" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              clearable: "",
                              placeholder: "请选择制单人",
                              filterable: "",
                            },
                            model: {
                              value: _vm.form0.created,
                              callback: function ($$v) {
                                _vm.$set(_vm.form0, "created", $$v)
                              },
                              expression: "form0.created",
                            },
                          },
                          _vm._l(_vm.createdBy, function (item) {
                            return _c("el-option", {
                              key: item.label,
                              attrs: { label: item.value, value: item.label },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "采购仓库" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              size: "small",
                              clearable: "",
                              placeholder: "请选择采购仓库",
                            },
                            model: {
                              value: _vm.form0.war,
                              callback: function ($$v) {
                                _vm.$set(_vm.form0, "war", $$v)
                              },
                              expression: "form0.war",
                            },
                          },
                          _vm._l(_vm.wareList.list, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "采购商品" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入采购商品名称/品牌" },
                          model: {
                            value: _vm.form0.goodInfo,
                            callback: function ($$v) {
                              _vm.$set(_vm.form0, "goodInfo", $$v)
                            },
                            expression: "form0.goodInfo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { label: "采购部门" } }, [
                      _c(
                        "div",
                        { staticClass: "selectTree" },
                        [
                          _c("treeselect", {
                            attrs: {
                              options: _vm.options,
                              "search-nested": "",
                              normalizer: _vm.normalizer,
                              noResultsText: "未找到",
                              placeholder: "请选择",
                            },
                            model: {
                              value: _vm.form0.department,
                              callback: function ($$v) {
                                _vm.$set(_vm.form0, "department", $$v)
                              },
                              expression: "form0.department",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "供应商" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              clearable: "",
                              placeholder: "请选择供应商",
                              filterable: "",
                            },
                            model: {
                              value: _vm.form0.supplier,
                              callback: function ($$v) {
                                _vm.$set(_vm.form0, "supplier", $$v)
                              },
                              expression: "form0.supplier",
                            },
                          },
                          _vm._l(_vm.supplierBy.list, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.supplierName,
                                value: item.supplierName,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "制单时间" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            clearable: "",
                            type: "daterange",
                            size: "small",
                            align: "right",
                            "unlink-panels": "",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "yyyy-MM-dd",
                            "picker-options": _vm.pickerOptions,
                          },
                          model: {
                            value: _vm.form0.date,
                            callback: function ($$v) {
                              _vm.$set(_vm.form0, "date", $$v)
                            },
                            expression: "form0.date",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.searchEvent()
                              },
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.searchEvent()
                              },
                            },
                          },
                          [_vm._v("搜索")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.resetEvent()
                              },
                            },
                          },
                          [_vm._v("重置")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.activeName == 1
              ? _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: { model: _vm.form1, "label-width": "70px" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "采购编号" } },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "small",
                            clearable: "",
                            placeholder: "请输入采购编号",
                          },
                          model: {
                            value: _vm.form1.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.form1, "code", $$v)
                            },
                            expression: "form1.code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "制单人" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              clearable: "",
                              placeholder: "请选择制单人",
                              filterable: "",
                            },
                            model: {
                              value: _vm.form1.created,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "created", $$v)
                              },
                              expression: "form1.created",
                            },
                          },
                          _vm._l(_vm.createdBy, function (item) {
                            return _c("el-option", {
                              key: item.label,
                              attrs: { label: item.value, value: item.label },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "采购仓库" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              size: "small",
                              clearable: "",
                              placeholder: "请选择采购仓库",
                            },
                            model: {
                              value: _vm.form1.war,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "war", $$v)
                              },
                              expression: "form1.war",
                            },
                          },
                          _vm._l(_vm.wareList.list, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "采购商品" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入采购商品名称/品牌" },
                          model: {
                            value: _vm.form1.goodInfo,
                            callback: function ($$v) {
                              _vm.$set(_vm.form1, "goodInfo", $$v)
                            },
                            expression: "form1.goodInfo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { label: "采购部门" } }, [
                      _c(
                        "div",
                        { staticClass: "selectTree" },
                        [
                          _c("treeselect", {
                            attrs: {
                              options: _vm.options,
                              "search-nested": "",
                              normalizer: _vm.normalizer,
                              noResultsText: "未找到",
                              placeholder: "请选择",
                            },
                            model: {
                              value: _vm.form1.department,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "department", $$v)
                              },
                              expression: "form1.department",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "供应商" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              clearable: "",
                              placeholder: "请选择供应商",
                              filterable: "",
                            },
                            model: {
                              value: _vm.form1.supplier,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "supplier", $$v)
                              },
                              expression: "form1.supplier",
                            },
                          },
                          _vm._l(_vm.supplierBy.list, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.supplierName,
                                value: item.supplierName,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "制单时间" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            clearable: "",
                            type: "daterange",
                            size: "small",
                            align: "right",
                            "unlink-panels": "",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "yyyy-MM-dd",
                            "picker-options": _vm.pickerOptions,
                          },
                          model: {
                            value: _vm.form1.date,
                            callback: function ($$v) {
                              _vm.$set(_vm.form1, "date", $$v)
                            },
                            expression: "form1.date",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.searchEvent()
                              },
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.searchEvent()
                              },
                            },
                          },
                          [_vm._v("搜索")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.resetEvent()
                              },
                            },
                          },
                          [_vm._v("重置")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.activeName == 2
              ? _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: { model: _vm.form2, "label-width": "70px" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "采购编号" } },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "small",
                            clearable: "",
                            placeholder: "请输入采购编号",
                          },
                          model: {
                            value: _vm.form2.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.form2, "code", $$v)
                            },
                            expression: "form2.code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "制单人" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              clearable: "",
                              placeholder: "请选择制单人",
                              filterable: "",
                            },
                            model: {
                              value: _vm.form2.created,
                              callback: function ($$v) {
                                _vm.$set(_vm.form2, "created", $$v)
                              },
                              expression: "form2.created",
                            },
                          },
                          _vm._l(_vm.createdBy, function (item) {
                            return _c("el-option", {
                              key: item.label,
                              attrs: { label: item.value, value: item.label },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "采购仓库" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              size: "small",
                              clearable: "",
                              placeholder: "请选择采购仓库",
                            },
                            model: {
                              value: _vm.form2.war,
                              callback: function ($$v) {
                                _vm.$set(_vm.form2, "war", $$v)
                              },
                              expression: "form2.war",
                            },
                          },
                          _vm._l(_vm.wareList.list, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "采购商品" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入采购商品名称/品牌" },
                          model: {
                            value: _vm.form2.goodInfo,
                            callback: function ($$v) {
                              _vm.$set(_vm.form2, "goodInfo", $$v)
                            },
                            expression: "form2.goodInfo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { label: "采购部门" } }, [
                      _c(
                        "div",
                        { staticClass: "selectTree" },
                        [
                          _c("treeselect", {
                            attrs: {
                              options: _vm.options,
                              "search-nested": "",
                              normalizer: _vm.normalizer,
                              noResultsText: "未找到",
                              placeholder: "请选择",
                            },
                            model: {
                              value: _vm.form2.department,
                              callback: function ($$v) {
                                _vm.$set(_vm.form2, "department", $$v)
                              },
                              expression: "form2.department",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "供应商" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              clearable: "",
                              placeholder: "请选择供应商",
                              filterable: "",
                            },
                            model: {
                              value: _vm.form2.supplier,
                              callback: function ($$v) {
                                _vm.$set(_vm.form2, "supplier", $$v)
                              },
                              expression: "form2.supplier",
                            },
                          },
                          _vm._l(_vm.supplierBy.list, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.supplierName,
                                value: item.supplierName,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "制单时间" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            clearable: "",
                            type: "daterange",
                            size: "small",
                            align: "right",
                            "unlink-panels": "",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "yyyy-MM-dd",
                            "picker-options": _vm.pickerOptions,
                          },
                          model: {
                            value: _vm.form2.date,
                            callback: function ($$v) {
                              _vm.$set(_vm.form2, "date", $$v)
                            },
                            expression: "form2.date",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.searchEvent()
                              },
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.searchEvent()
                              },
                            },
                          },
                          [_vm._v("搜索")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.resetEvent()
                              },
                            },
                          },
                          [_vm._v("重置")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.activeName == 3
              ? _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: { model: _vm.form3, "label-width": "70px" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "采购编号" } },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "small",
                            clearable: "",
                            placeholder: "请输入采购编号",
                          },
                          model: {
                            value: _vm.form3.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.form3, "code", $$v)
                            },
                            expression: "form3.code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "制单人" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              clearable: "",
                              placeholder: "请选择制单人",
                              filterable: "",
                            },
                            model: {
                              value: _vm.form3.created,
                              callback: function ($$v) {
                                _vm.$set(_vm.form3, "created", $$v)
                              },
                              expression: "form3.created",
                            },
                          },
                          _vm._l(_vm.createdBy, function (item) {
                            return _c("el-option", {
                              key: item.label,
                              attrs: { label: item.value, value: item.label },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "采购仓库" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              size: "small",
                              clearable: "",
                              placeholder: "请选择采购仓库",
                            },
                            model: {
                              value: _vm.form3.war,
                              callback: function ($$v) {
                                _vm.$set(_vm.form3, "war", $$v)
                              },
                              expression: "form3.war",
                            },
                          },
                          _vm._l(_vm.wareList.list, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "采购商品" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入采购商品名称/品牌" },
                          model: {
                            value: _vm.form3.goodInfo,
                            callback: function ($$v) {
                              _vm.$set(_vm.form3, "goodInfo", $$v)
                            },
                            expression: "form3.goodInfo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { label: "采购部门" } }, [
                      _c(
                        "div",
                        { staticClass: "selectTree" },
                        [
                          _c("treeselect", {
                            attrs: {
                              options: _vm.options,
                              "search-nested": "",
                              normalizer: _vm.normalizer,
                              noResultsText: "未找到",
                              placeholder: "请选择",
                            },
                            model: {
                              value: _vm.form3.department,
                              callback: function ($$v) {
                                _vm.$set(_vm.form3, "department", $$v)
                              },
                              expression: "form3.department",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "供应商" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              clearable: "",
                              placeholder: "请选择供应商",
                              filterable: "",
                            },
                            model: {
                              value: _vm.form3.supplier,
                              callback: function ($$v) {
                                _vm.$set(_vm.form3, "supplier", $$v)
                              },
                              expression: "form3.supplier",
                            },
                          },
                          _vm._l(_vm.supplierBy.list, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.supplierName,
                                value: item.supplierName,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "制单时间" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            clearable: "",
                            type: "daterange",
                            size: "small",
                            align: "right",
                            "unlink-panels": "",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "yyyy-MM-dd",
                            "picker-options": _vm.pickerOptions,
                          },
                          model: {
                            value: _vm.form3.date,
                            callback: function ($$v) {
                              _vm.$set(_vm.form3, "date", $$v)
                            },
                            expression: "form3.date",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.searchEvent()
                              },
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.searchEvent()
                              },
                            },
                          },
                          [_vm._v("搜索")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.resetEvent()
                              },
                            },
                          },
                          [_vm._v("重置")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "btns" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isShowForm,
                  expression: "!isShowForm",
                },
              ],
              staticStyle: { opacity: "0" },
              attrs: { disabled: "", type: "primary", size: "mini" },
            },
            [
              _c(
                "span",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c("img", {
                    staticStyle: {
                      width: "14px",
                      height: "14px",
                      "margin-right": "5px",
                    },
                    attrs: {
                      src: require("../../assets/icon/icon_daochu.png"),
                    },
                  }),
                  _vm._v("导出 "),
                ]
              ),
            ]
          ),
          _vm.activeName == 3 && _vm.parArray.indexOf("exportCgCode") != -1
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.exports },
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("img", {
                        staticStyle: {
                          width: "14px",
                          height: "14px",
                          "margin-right": "5px",
                        },
                        attrs: {
                          src: require("../../assets/icon/icon_daochu.png"),
                        },
                      }),
                      _vm._v("导出 "),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.activeName == 3 &&
                    _vm.parArray.indexOf("printingCgCode") != -1,
                  expression:
                    "activeName == 3 && parArray.indexOf('printingCgCode') != -1",
                },
              ],
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.tpPrintJS },
            },
            [
              _c(
                "span",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c("img", {
                    staticStyle: {
                      width: "14px",
                      height: "14px",
                      "margin-right": "5px",
                    },
                    attrs: { src: require("../../assets/icon/dayin.png") },
                  }),
                  _vm._v("打印 "),
                ]
              ),
            ]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isShowForm,
                  expression: "!isShowForm",
                },
              ],
              staticStyle: { position: "absolute", right: "10px" },
              attrs: { type: "primary", size: "mini" },
              on: {
                click: function ($event) {
                  _vm.isShowForm = true
                },
              },
            },
            [_vm._v("搜索展开")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tableContext" },
        [
          _c(
            "el-table",
            {
              attrs: { data: _vm.tableData.list },
              on: {
                "selection-change": function ($event) {
                  _vm.multipleSelection = $event
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { label: "序号", type: "index", width: "50" },
              }),
              _c("el-table-column", {
                attrs: { label: "制单时间", "min-width": "110px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$moment(scope.row.createdTime)) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "采购编号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.rowClick(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.purchaseOrderNo))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "制单人", prop: "createdName" },
              }),
              _c("el-table-column", {
                attrs: { label: "采购数量", prop: "purchaseQuantity" },
              }),
              _c("el-table-column", {
                attrs: { label: "入库数量", prop: "inDepotQuantity" },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "120px",
                  label: "未入库数量",
                  prop: "notInDepotQuantity",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "采购金额", prop: "purchaseAmount" },
              }),
              _vm.activeName == 2
                ? _c("el-table-column", {
                    attrs: { label: "驳回时间", "min-width": "100px" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$moment(scope.row.rejectionTime))
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2494150529
                    ),
                  })
                : _vm._e(),
              _vm.activeName == 2
                ? _c("el-table-column", {
                    attrs: { "show-overflow-tooltip": "", label: "驳回原因" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.rejectionReason)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3814056997
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "备注", prop: "comment" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "180px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.activeName == 0
                          ? _c("p", { staticClass: "operation" }, [
                              scope.row.isSelf == 1 &&
                              _vm.parArray.indexOf("approveCg") != -1
                                ? _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.submitAudit(
                                            scope.row.purchaseOrderNo
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("提交审核")]
                                  )
                                : _vm._e(),
                              scope.row.isSelf == 1 &&
                              _vm.parArray.indexOf("fixCg") != -1
                                ? _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.fixPurchas(scope.row, 1)
                                        },
                                      },
                                    },
                                    [_vm._v("修改")]
                                  )
                                : _vm._e(),
                              scope.row.isSelf == 1 &&
                              _vm.parArray.indexOf("delectCg") != -1
                                ? _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.closeEvent(
                                            scope.row,
                                            scope.$index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("关闭")]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm.activeName == 1 &&
                        _vm.parArray.indexOf("pzCg") != -1
                          ? _c("p", { staticClass: "operation" }, [
                              scope.row.isApprove == 1
                                ? _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          ;(_vm.textare = ""),
                                            (_vm.approveObj = scope.row),
                                            (_vm.approveObj.type = 1),
                                            (_vm.isApprove = true)
                                        },
                                      },
                                    },
                                    [_vm._v("批准")]
                                  )
                                : _vm._e(),
                              scope.row.isApprove == 1 &&
                              _vm.parArray.indexOf("bhCg") != -1
                                ? _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          ;(_vm.textare = ""),
                                            (_vm.approveObj = scope.row),
                                            (_vm.approveObj.type = 2),
                                            (_vm.isApprove = true)
                                        },
                                      },
                                    },
                                    [_vm._v("驳回")]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm.activeName == 2 &&
                        _vm.parArray.indexOf("againCgCode") != -1
                          ? _c("p", { staticClass: "operation" }, [
                              scope.row.isSelf == 1
                                ? _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.reopen(
                                            scope.row.purchaseOrderNo
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("重开")]
                                  )
                                : _vm._e(),
                              scope.row.isSelf == 1 &&
                              _vm.parArray.indexOf("delectCg") != -1
                                ? _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.closeEvent(
                                            scope.row,
                                            scope.$index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("关闭")]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm.activeName == 3
                          ? _c("p", { staticClass: "operation" }, [
                              scope.row.isSelf == 1 &&
                              scope.row.isConfirm != 2 &&
                              _vm.parArray.indexOf("trurCg") != -1
                                ? _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.confirm(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("确认")]
                                  )
                                : _vm._e(),
                              _vm.parArray.indexOf("recordCg") != -1
                                ? _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.record(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("记录")]
                                  )
                                : _vm._e(),
                              _vm.parArray.indexOf("fixFinishCode") != -1
                                ? _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.fixPurchas(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("修改")]
                                  )
                                : _vm._e(),
                              scope.row.isSelf == 1 &&
                              scope.row.notInDepotQuantity != 0 &&
                              _vm.parArray.indexOf("warehousingCode") != -1
                                ? _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.warehousing(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("入库")]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("p", { staticStyle: { height: "30px" } }),
      _vm.tableData.totalNum >= 10
        ? _c("div", { staticClass: "page" }, [
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.pageNo,
                    "page-sizes": [10, 20, 50, 100, 200],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.tableData.totalNum,
                    "prev-text": "上一页",
                    "next-text": "下一页",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-drawer",
        {
          attrs: {
            "show-close": false,
            "append-to-body": "",
            size: "70%",
            visible: _vm.drawer,
            direction: "rtl",
            withHeader: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("div", { staticClass: "drawerContext" }, [
            _c("div", { staticClass: "title" }, [
              _c("i", {
                staticClass: "el-icon-close",
                staticStyle: { "margin-left": "10px", cursor: "pointer" },
                on: {
                  click: function ($event) {
                    _vm.drawer = false
                  },
                },
              }),
              _c("span", { staticStyle: { "margin-left": "20px" } }, [
                _vm._v("采购单详情"),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "context" },
              [
                _vm._v(
                  " 创建时间：" +
                    _vm._s(_vm.$moment(_vm.detailObj.createdTime)) +
                    " "
                ),
                _c(
                  "el-table",
                  { attrs: { data: _vm.detailObj.itemVOs } },
                  [
                    _c("el-table-column", {
                      attrs: { label: "序号", type: "index", width: "55" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "创建时间", "min-width": "100" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(_vm.$moment(scope.row.createdTime))
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "supplierName", label: "供应商" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "createdName", label: "创建人" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "purchaseOrgName", label: "采购部门" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "采购仓库" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.mapWarName(scope.row.depotVos)) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "商品类型" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    ["商品", "赠品"][
                                      scope.row.purchaseProdType - 1
                                    ]
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "min-width": "100",
                        "show-overflow-tooltip": "",
                        prop: "purchaseProdName",
                        label: "采购商品",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "采购图片" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: "查看更多",
                                    placement: "top",
                                  },
                                },
                                [
                                  scope.row.purchaseImage
                                    ? _c("el-image", {
                                        staticStyle: {
                                          width: "60px",
                                          height: "60px",
                                          cursor: "pointer",
                                        },
                                        attrs: {
                                          src:
                                            _vm.ImgHttps +
                                            scope.row.purchaseImage.split(
                                              ","
                                            )[0],
                                        },
                                        on: {
                                          click: function ($event) {
                                            ;(_vm.imageSrc =
                                              scope.row.purchaseImage),
                                              (_vm.dialogVisible = true)
                                          },
                                        },
                                      })
                                    : _c("span", [_vm._v("/")]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "purchaseProdBrandName",
                        label: "采购品牌",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "purchaseProdQuantity",
                        label: "采购数量",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "purchaseProdSpecificationName",
                        label: "采购规格",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "purchaseProdPrice", label: "采购单价" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "purchaseProdAmount", label: "采购金额" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "show-close": false,
            "append-to-body": "",
            size: "70%",
            visible: _vm.drawerRecord,
            direction: "rtl",
            withHeader: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerRecord = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "drawerContext" },
            [
              _c("div", { staticClass: "title" }, [
                _c("i", {
                  staticClass: "el-icon-close",
                  staticStyle: { "margin-left": "10px", cursor: "pointer" },
                  on: {
                    click: function ($event) {
                      _vm.drawerRecord = false
                    },
                  },
                }),
                _c("span", { staticStyle: { "margin-left": "20px" } }, [
                  _vm._v("记录"),
                ]),
              ]),
              _c(
                "el-table",
                { attrs: { data: _vm.recordData } },
                [
                  _c("el-table-column", {
                    attrs: { label: "采购编号" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#4168e7",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$refs.cgjl.rowClick(
                                      scope.row.purchaseOrderNo,
                                      1
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.purchaseOrderNo))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "采购入库编号" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#4168e7",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$refs.cgjl.rowClick(
                                      scope.row.orderPurchaseInOrderNo,
                                      2
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.orderPurchaseInOrderNo))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "采购退货编号" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#4168e7",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$refs.cgjl.rowClick(
                                      scope.row.purchaseReturnOrderNo,
                                      4
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.purchaseReturnOrderNo))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "采购换货编号" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#4168e7",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$refs.cgjl.rowClick(
                                      scope.row.purchaseExchangeOrderNo,
                                      3
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(scope.row.purchaseExchangeOrderNo)
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "图片",
            visible: _vm.dialogVisible,
            "append-to-body": true,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.imageSrc
            ? _c(
                "div",
                { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                _vm._l(_vm.imageSrc.split(","), function (item) {
                  return item.length
                    ? _c("el-image", {
                        directives: [
                          { name: "image-preview", rawName: "v-image-preview" },
                        ],
                        key: item,
                        staticStyle: {
                          "margin-right": "10px",
                          width: "100px",
                          height: "100px",
                        },
                        attrs: { src: _vm.ImgHttps + item },
                      })
                    : _vm._e()
                }),
                1
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审批",
            visible: _vm.isApprove,
            "append-to-body": true,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isApprove = $event
            },
          },
        },
        [
          _vm.approveObj.type == 1
            ? _c("div", [_vm._v("确定批准采购单吗?")])
            : _vm._e(),
          _vm.approveObj.type == 2
            ? _c("div", [
                _c("div", [_vm._v("确定驳回采购单吗?")]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "10px",
                      display: "flex",
                      "align-items": "center",
                    },
                  },
                  [
                    _c("span", { staticStyle: { width: "80px" } }, [
                      _vm._v(" 驳回理由: "),
                    ]),
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        autosize: "",
                        placeholder: "请输入内容",
                      },
                      model: {
                        value: _vm.textare,
                        callback: function ($$v) {
                          _vm.textare = $$v
                        },
                        expression: "textare",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.approve } },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isApprove = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("cgjl", { ref: "cgjl" }),
      _c(
        "vue-easy-print",
        { ref: "easyPrint" },
        _vm._l(_vm.printData, function (item) {
          return _c(
            "div",
            { key: item.id, staticStyle: { "margin-bottom": "20px" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    border: "1px solid #333",
                    "border-bottom": "0",
                    display: "flex",
                    "justify-content": "center",
                  },
                },
                [_vm._v(" 广东九航贸易有限公司 ")]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    border: "1px solid #333",
                    "border-bottom": "0",
                    display: "flex",
                    "justify-content": "center",
                  },
                },
                [_vm._v(" 采购单 ")]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "0px 10px",
                    border: "1px solid #333",
                    "border-bottom": "0",
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c("span", [
                    _vm._v("单据编号:" + _vm._s(item.list.purchaseOrderNo)),
                  ]),
                  _c("span", [
                    _vm._v(
                      "创建日期:" + _vm._s(_vm.$moment(item.list.createdTime))
                    ),
                  ]),
                ]
              ),
              _c(
                "table",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { border: "1", cellpadding: "0", cellspacing: "0" },
                },
                [
                  _c("tr", [
                    _c("th", { attrs: { width: "5%" } }, [_vm._v("序号")]),
                    _c("th", { attrs: { width: "5%" } }, [_vm._v("采购部门")]),
                    _c("th", { attrs: { width: "7%" } }, [_vm._v("供应商")]),
                    _c("th", { attrs: { width: "7%" } }, [_vm._v("采购类型")]),
                    _c("th", { attrs: { width: "5%" } }, [_vm._v("采购商品")]),
                    _c("th", { attrs: { width: "5%" } }, [_vm._v("采购规格")]),
                    _c("th", { attrs: { width: "5%" } }, [_vm._v("采购品牌")]),
                    _c("th", { attrs: { width: "5%" } }, [_vm._v("采购数量")]),
                    _c("th", { attrs: { width: "5%" } }, [_vm._v("采购金额")]),
                    _c("th", { attrs: { width: "5%" } }, [_vm._v("采购仓库")]),
                  ]),
                  _vm._l(item.list.itemVOs, function (row, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [_vm._v(_vm._s(index))]),
                      _c("td", [_vm._v(_vm._s(row.purchaseOrgName))]),
                      _c("td", [_vm._v(_vm._s(row.supplierName))]),
                      _c("td", [
                        _vm._v(
                          _vm._s(row.purchaseProdType == 1 ? "商品" : "赠品")
                        ),
                      ]),
                      _c("td", [_vm._v(_vm._s(row.purchaseProdName))]),
                      _c("td", [
                        _vm._v(_vm._s(row.purchaseProdSpecificationName)),
                      ]),
                      _c("td", [_vm._v(_vm._s(row.purchaseProdBrandName))]),
                      _c("td", [_vm._v(_vm._s(row.purchaseProdQuantity))]),
                      _c("td", [_vm._v(_vm._s(row.purchaseProdAmount))]),
                      _c("td", [_vm._v(_vm._s(_vm.mapWarName(row.depotVos)))]),
                    ])
                  }),
                ],
                2
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "0px 10px",
                    border: "1px solid #333",
                    "border-top": "0",
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c("span", [
                    _vm._v("制单人:" + _vm._s(item.list.createdName)),
                  ]),
                  _c("span", [
                    _vm._v("审批人:" + _vm._s(item.list.purchaseManagerName)),
                  ]),
                ]
              ),
              _c("div", { staticStyle: { "page-break-after": "always" } }),
            ]
          )
        }),
        0
      ),
      _c("div", { staticStyle: { height: "100px" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }